// src/i18n/index.js
// Configuration i18n - NE PAS MODIFIER

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr';
import en from './en';

// Déterminer la langue du navigateur
const getDefaultLanguage = () => {
  const browserLang = navigator.language.split('-')[0];
  if (browserLang === 'fr') return 'fr';
  if (browserLang === 'en') return 'en';
  return 'fr'; // Français par défaut
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: getDefaultLanguage(),
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // React protège déjà contre les injections XSS
    },
    ns: ['translation'],
    defaultNS: 'translation',
    react: {
      useSuspense: false, // Évite les problèmes de suspense
    },
  });

export default i18n;